"use client";
import Link from "next/link";
import type { ReactNode } from "react";

type PillProps = {
  icon?: ReactNode;
  label: string;
  href?: string;
  active?: boolean;
  onClick?: () => void;
  className?: string;
};

/**
 * Pill-shaped quick-access chip (Quick Access Category Pills row). Scrolls
 * horizontally on mobile when several are placed in a `flex overflow-x-auto`
 * container — see HomePage's category pills section.
 */
export default function Pill({ icon, label, href, active = false, onClick, className = "" }: PillProps) {
  const styles = active
    ? {
        background: "linear-gradient(90deg, rgba(0,212,255,0.18), rgba(124,58,237,0.18))",
        border: "1px solid rgba(0,212,255,0.45)",
        color: "#f1f5f9",
      }
    : {
        background: "rgba(16,24,39,0.55)",
        border: "1px solid rgba(91,127,255,0.18)",
        color: "#cbd5e1",
      };

  const inner = (
    <span
      className={`inline-flex shrink-0 items-center gap-2 rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors duration-150 hover:border-cyan-400/50 hover:text-white ${className}`}
      style={styles}
    >
      {icon}
      {label}
    </span>
  );

  if (href) {
    return (
      <Link href={href} onClick={onClick}>
        {inner}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick}>
      {inner}
    </button>
  );
}
